var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHunterStoryBoard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 362,
    viewBox: "0 0 626 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_12_35442)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 321.32,
    rx: 11.2524,
    transform: "matrix(1 0 0 -1 20 339.32)",
    fill: "url(#paint0_linear_12_35442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.62622,
    y: 5.62622,
    width: 597.252,
    height: 332.572,
    rx: 16.8787,
    transform: "matrix(1 0 0 -1 20 350.572)",
    stroke: "url(#paint1_linear_12_35442)",
    strokeWidth: 11.2524
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_12_35442",
    x: 0.308233,
    y: 0.55872,
    width: 625.384,
    height: 360.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.93835
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.281311
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.152941 0 0 0 0 0.00392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_35442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.25049
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_12_35442",
    result: "effect2_dropShadow_12_35442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12_35442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_35442",
    x1: 293,
    y1: -4.91994e-7,
    x2: 278.635,
    y2: 527.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#B7570E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E2401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_35442",
    x1: 429.631,
    y1: 20.5846,
    x2: 211.339,
    y2: 293.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52422,
    stopColor: "#FCA22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728844,
    stopColor: "#CD7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#973E04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterStoryBoard2);
export default __webpack_public_path__ + "static/media/hunter-story-board-2.b7a2b3c9ffe94b4f56a967741246e033.svg";
export { ForwardRef as ReactComponent };